var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-col",
    {
      attrs: {
        cols: "12"
      }
    },
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" Pending Access ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-data-table",
                {
                  attrs: {
                    headers: _vm.headersPending,
                    items: _vm.accessPendingList,
                    loading: !_vm.loaded
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.email",
                      fn: function fn(_ref) {
                        var item = _ref.item
                        return [
                          _c("div", [_c("b", [_vm._v(_vm._s(item.name))])]),
                          _c("div", [_vm._v(_vm._s(item.email))])
                        ]
                      }
                    },
                    {
                      key: "item.service_name",
                      fn: function fn(_ref2) {
                        var item = _ref2.item
                        return [
                          _vm.link(item.service_id)
                            ? _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: _vm.link(item.service_id)
                                  }
                                },
                                [_vm._v(" " + _vm._s(item.service_name) + " ")]
                              )
                            : _c("span", [
                                _vm._v(" " + _vm._s(item.service_name) + " ")
                              ])
                        ]
                      }
                    },
                    {
                      key: "item.id",
                      fn: function fn(_ref3) {
                        var item = _ref3.item
                        return [
                          item.type === "received"
                            ? [
                                _c(
                                  "gg-btn",
                                  {
                                    staticClass: "my-0",
                                    attrs: {
                                      text: ""
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.openPendingActionDialog(
                                          item.id,
                                          _vm.pendingActionsTypes.accept
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(" Accept "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "visually-hidden text-lowercase"
                                      },
                                      [_vm._v("button")]
                                    )
                                  ]
                                ),
                                _c(
                                  "gg-btn",
                                  {
                                    staticClass: "my-0",
                                    attrs: {
                                      text: ""
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.openPendingActionDialog(
                                          item.id,
                                          _vm.pendingActionsTypes.reject
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(" Reject "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "visually-hidden text-lowercase"
                                      },
                                      [_vm._v("button")]
                                    )
                                  ]
                                )
                              ]
                            : [
                                _c(
                                  "gg-btn",
                                  {
                                    staticClass: "my-0",
                                    attrs: {
                                      text: ""
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.openPendingActionDialog(
                                          item.id,
                                          _vm.pendingActionsTypes.resend
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(" Resend "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "visually-hidden text-lowercase"
                                      },
                                      [_vm._v("button")]
                                    )
                                  ]
                                ),
                                _c(
                                  "gg-btn",
                                  {
                                    staticClass: "my-0",
                                    attrs: {
                                      text: ""
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.openPendingActionDialog(
                                          item.id,
                                          _vm.pendingActionsTypes.revoke
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(" Revoke "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "visually-hidden text-lowercase"
                                      },
                                      [_vm._v("button")]
                                    )
                                  ]
                                )
                              ]
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("v-progress-linear", {
                    attrs: {
                      slot: "progress",
                      color: "green",
                      height: "2",
                      indeterminate: ""
                    },
                    slot: "progress"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("pending-action-modal", {
        attrs: {
          opened: _vm.pendingActionDialog,
          "action-type": _vm.pendingActionType,
          id: _vm.selectedPendingId
        },
        on: {
          close: _vm.closePendingActionDialog
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }